import React from 'react';

import { $searchInput } from './style';

const SearchInput = ({ value, onChange }) => {
  return (
    <input
      value={value}
      onChange={onChange}
      css={$searchInput} placeholder='Search standards'
    />
  );
};

export default SearchInput;
